export default __webpack_public_path__ + "50970f2.png";